import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "@/i18n/LanguageContext";
import logoFD from "@/assets/logo-fd-round.jpeg";

const Landing = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleEnter = () => {
    navigate("/home");
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <Helmet>
        <title>Federico Duronio — Formador de Barista y Café de Especialidad</title>
        <meta name="description" content="Entra al sitio oficial de Federico Duronio, Campeón Nacional de Latte Art y Coffee Man de BFC. Formación, consultoría y máquinas BFC." />
        <link rel="canonical" href="https://federicoduronio.com/" />
        <meta property="og:title" content="Federico Duronio — Formador de Barista y Café de Especialidad" />
        <meta property="og:description" content="Sitio oficial: formación, consultoría y máquinas de café BFC." />
        <meta property="og:url" content="https://federicoduronio.com/" />
      </Helmet>
      <h1 className="sr-only">Federico Duronio — Formación de Barista y Café de Especialidad</h1>

      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/videos/intro-video.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-espresso/40" />

      {/* Centered Logo */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center">
        <button
          onClick={handleEnter}
          className="group relative transition-transform duration-500 hover:scale-105 focus:outline-none"
        >
          <div className="w-36 h-36 md:w-48 md:h-48 lg:w-56 lg:h-56 rounded-full overflow-hidden border-2 border-gold/60 shadow-2xl transition-all duration-500 group-hover:border-gold group-hover:shadow-gold/30">
            <img
              src={logoFD}
              alt="Federico Duronio - Entrar"
              className="w-full h-full object-cover"
              width={224}
              height={224}
              fetchPriority="high"
              decoding="async"
            />
          </div>
          
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-full bg-gold/0 group-hover:bg-gold/10 transition-all duration-500" />
        </button>

        {/* Enter text */}
        <p className="mt-8 text-cream/80 text-lg md:text-xl font-light tracking-widest uppercase animate-pulse">
          {t("landing", "clickParaEntrar")}
        </p>
      </div>
    </div>
  );
};

export default Landing;
